import axios from "axios";
import createManagementAxios from "@shared/createManagementAxios.cjs";

// same-origin 호출 — nginx /api/ proxy를 통해 자기 도메인 백엔드로 라우팅
// (dev-provider.hidia.kr → dev DB, provider.hidia.kr → 운영 DB)
const baseURL = "";

const instance = createManagementAxios({
  axios,
  baseURL,
  storage: localStorage,
});

export default instance;
